import React from 'react'

export const PaginaInicialIpgs: React.FC = () => <h1>Página inicial do iPGS</h1>
